import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/redux';
import { UserRole } from '@/types';

// Mirrors AdminRoute — gates "My Billing" to a platform's own login only. Nested inside
// ProtectedRoute (see App.tsx), which already handles the "not logged in at all" case, so this
// only ever needs to check the role: anyone else (admin included) gets bounced to the regular
// dashboard rather than an "Access Denied" wall, since being an admin isn't wrong here, just the
// wrong page — there's no platform id to show billing for.
export function PlatformRoute() {
  const user = useCurrentUser();

  if (user !== UserRole.PLATFORM) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
